import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import Chart from "react-apexcharts";
import { createGlobalStyle } from 'styled-components';
import { DOCUMENT_LIST } from '../../prefixed/documents';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {stringToHex} from "../forms/validator";
import axios from 'axios';

const JComponent= ({modalObject}) => {
  const navigate=useNavigate();
  const [rows,setRows]=useState([]);
  const [summaryRows,setSummaryRows]=useState([]);
  const [role,setRole]=useState("");
  useEffect(()=>{
	  if(localStorage.getItem("_xoxre")==="9999"){
		  setRole("9999");
	  }
  },[])  
  useEffect(()=>{
	fetchProjectFundingAgencyWise();
  },[]);
  const getAssetType=(_catId,assetsCategoryList)=>{
	for(let i=0;i<assetsCategoryList.length;i++){
	  if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
	}
	return(_catId);
  }
  const getImplAgencyById=(_id,implAgencyList)=>{
	for(let i=0;i<implAgencyList.length;i++){
	  if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
	}
	return(_id);
  }
  const loadAssetCategoryList=async()=>{
	var config = {
	  method: 'post',
	  url: API_CORE_SERVER+"/api/get_asset_category.php",
	  headers: { 
		//'Content-Type': 'application/x-www-form-urlencoded',
		'Content-Type': 'application/json', 
	  },
	  data:{name:'hellominni'}
	  };
	 let records=await axios(config)
	  .then((response)=>{
		if(response.status===200 && response.data){
		  return(response.data);
		}
		return(null);
	  }).catch((response)=>{
		return(null);
	  });
	  return(records);
	}
	
	const loadImplAgencyList=async()=>{
	var config = {
	  method: 'post',
	  url: API_CORE_SERVER+"/api/get_impl_agency.php",
	  headers: { 
		//'Content-Type': 'application/x-www-form-urlencoded',
		'Content-Type': 'application/json', 
	  },
	  data:{name:'hellominni'}
	  };
	  let records=await axios(config)
	  .then((response)=>{
		if(response.status===200 && response.data){
		  return(response.data);
		}
		return(null);
	  }).catch((response)=>{
		return(null);
	  });
	  return(records);
	}
	const getValueGroupWise=(_inArray,_key,_filter,_returnKey)=>{
		
		for(let i=0;i<_inArray.length;i++){
		  let data=_inArray[i];
		  if(data.id===_key && data.wStatus===_filter){
			return(isNaN(data[_returnKey])?0:data[_returnKey]);
		  }
		}
		return(0);
	}
	const loadContractorList=async()=>{
		var config = {
		  method: 'post',
		  url: API_CORE_SERVER+"/api/get_contractors.php",
		  headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		  },
		  data:{name:'hellominni'}
		  };
		  let records=await axios(config)
		  .then((response)=>{
			if(response.status===200 && response.data){
				if(response.data.status==1)
			  		return(response.data.data);
			}
			return(null);
		  }).catch((response)=>{
			return(null);
		  });
		  return(records);
		}
	
	const loadProjectFundingAgecnyWise=async()=>{
		
		let _List=await loadContractorList();
		let _rows=[];
		  let _d={
			  token:localStorage.getItem("_xoxex"),
			  email:"jilani.it@gmail.com",
		  };
		  let idata=stringToHex(JSON.stringify(_d));
		  var config = {
			  method: 'post',
			  url: API_CORE_SERVER+"/api/document/get-documents-groupby-contractors.php",
			  headers: { 
				  'Content-Type': 'application/x-www-form-urlencoded',
				  //'Content-Type': 'application/json', 
			  },
			  data:"i="+idata
			};
		  let _returnRecs=await axios(config)
			  .then((response)=>{
				  if(response.status===200 && response.data){
					  let data=response.data;
					  
					  if(data.status===1 && data.data && data.data.length>0){
						  let records=data.data;
						  console.log(_List);
						  for(let i=0;i<_List.length;i++){
							 let _Id=_List[i].cname;
							 
							_rows.push({
							  id:_Id,
							  primaryName:_Id,
							  ongoingProjects:getValueGroupWise(records,_Id,"Ongoing","pCount"),
							  ongoingCost:(getValueGroupWise(records,_Id,"Ongoing","agrCost")/100000).toFixed(2),
							  completedProjects:getValueGroupWise(records,_Id,"Completed","pCount"),
							  completedCost:(getValueGroupWise(records,_Id,"Completed","agrCost")/100000).toFixed(2),
				  ongoingPerformance:getValueGroupWise(records,_Id,"Ongoing","performance"),
				  completedPerformance:getValueGroupWise(records,_Id,"Completed","performance"),
							  pCount:0
							});
						  } 
				return(_rows);
						  
					  }
					  
				  }
				  
			  }).catch((er)=>{
				  console.log(er);
			return([]);
			  })
		  return(_returnRecs)
	   } 
	
	   const fetchProjectFundingAgencyWise=async()=>{
		setSummaryRows([]);
		let recs=await loadProjectFundingAgecnyWise();
		setSummaryRows(recs);
		/*let html="";
		html+="<table class='table mt-4 fs85rem'>";
		html+="<thead>";
		html+="<tr style='fontSize:14px;color:#404040'>";
		html+="<th>Contractor</th>";
		html+="<th colspan='3' align='center'>Ongoing Project/Asset</th>";
		html+="<th colspan='3' align='center'>Completed Project/Asset</th>";
		html+="</tr>";
		html+="<tr style='fontSize:14px;color:#808080'>";
		html+="<td></td>";
		html+="<th align='center'>Count</th>";
		html+="<th align='center'>Agreement<br/> Cost (Lac)</th>";
		html+="<th align='center'>Performance%</th>";
		html+="<th align='center'>Count</th>";
		html+="<th align='center'>Agreement<br/> Cost (Lac)</th>";
		html+="<th align='center'>Performance%</th>";
		html+="</tr>";
		html+="</thead>";
		html+="<tbody>";
		for(let i=0;recs!=null && i<recs.length;i++){
			let item=recs[i];
				if((item.ongoingProjects!=0 || item.completedProjects!=0)){
					html+="<tr>";
					html+="<td>"+item.primaryName+"</td>";
					html+="<td align='center'>";
					html+="<div className='bg-primary rounded-pill text-white cursor-pointer'>";
					html+=""+item.ongoingProjects+"";
					html+="</div>";
					html+="</td>";
					html+="<td align='center'>"+item.ongoingCost+"</td>";
					if(Number(item.ongoingPerformance)>=70)
					html+="<td align='center' ><div class='bg-success px-2 rounded text-white'>"+Number(item.ongoingPerformance).toFixed(0)+"%</div></td>";
					else if(Number(item.ongoingPerformance)>40)
					html+="<td align='center' ><div class='bg-warning px-2 rounded text-white'>"+Number(item.ongoingPerformance).toFixed(0)+"%</div></td>";
					else html+="<td align='center' ><div class='bg-danger px-2 rounded text-white'>"+Number(item.ongoingPerformance).toFixed(0)+"%</div></td>";
					
					html+="<td align='center'>";
					html+="<div className='bg-success rounded-pill text-white cursor-pointer'>";
					html+=""+item.completedProjects+"";
					html+="</div>";	
					html+="</td>";
					html+="<td align='center'>"+item.completedCost+"</td>";
					if(Number(item.completedPerformance)>=70)
					html+="<td align='center'><div class='bg-success px-2 rounded text-white'>"+Number(item.completedPerformance).toFixed(0)+"%</div></td>";
					else if(Number(item.completedPerformance)>=40)
					html+="<td align='center'><div class='bg-warning px-2 rounded text-white'>"+Number(item.completedPerformance).toFixed(0)+"%</div></td>";
					else html+="<td align='center'><div class='bg-danger px-2 rounded text-white'>"+Number(item.completedPerformance).toFixed(0)+"%</div></td>";
					
					html+="</tr>";
				}
		}
		html+="</tbody></table>";
		document.getElementById("contractorPrfTable").innerHTML=html;
		*/
	
	}
/*<>
	<div className='row'>
		<div className='col-md-12 p-4'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-arrows-move'></i> Contractor Performance</h5>
			<div className='card'>
				<div className='card-body'>
					<div class='col-md-12 text-end'>
						<div class="btn-group">
							
						</div>
					</div>
					<div class='col-md-12' style={{overflowX:"scroll"}} id="contractorPrfTable">

					</div>
				</div>
			</div>
			
		</div>
		
	</div>
	</>*/
return(
	
	<>
	<div className='row'>
		<div className='col-md-12 p-4'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Contractor Performance.</h5>
			<div className='card'>
				<div className='card-body'>
					<table className='table mt-4 fs85rem'>
						<thead>
							<tr style={{fontSize:'14px',color:'#404040'}}>
								<td>Contractor</td>
								<td colspan="3" align='center'>Ongoing Project/Asset</td>
								<td colspan="3" align='center'>Completed Project/Asset</td>
							</tr>
							<tr style={{fontSize:'14px',color:'#808080'}}>
								<td></td>
								<td align='center'>Count</td>
								<td align='center'>Agreement<br/> Cost (Lac)</td>
								<td align='center'>Performance</td>

								<td align='center'>Count</td>
								<td align='center'>Agreement<br/> Cost (Lac)</td>
								<td align='center'>Performance</td>
							</tr>
						</thead>
						<tbody>
					{
						summaryRows && summaryRows.length>0 ?
						<> 
							{
								summaryRows.map((item,index)=>{
									return(
												(item.ongoingProjects!=0 || item.completedProjects!=0)?
												<tr>
													<td>
													<div className='text-primary cursor-pointer'
														onClick={e=>{
															navigate(URLPREFIX+"/list/document/contractors-projects-vba",{state:{requestFor:"contractors-view-by-admin",id:item.id,wstatus:"Ongoing",name:item.primaryName}})	
														}}
														>
															{item.primaryName}
														</div></td>
													<td align='center'>
														{item.ongoingProjects}
													</td>
													<td align='center'>{item.ongoingCost}</td>
													<td align='center'>{
														Number(item.ongoingPerformance)>=70?
														<div class='bg-success px-2 rounded text-white'>{Number(item.ongoingPerformance).toFixed(0)}%</div>
														:Number(item.ongoingPerformance)>=50?
														<div class='bg-warning px-2 rounded text-white'>{Number(item.ongoingPerformance).toFixed(0)}%</div>
														:
														<div class='bg-danger px-2 rounded text-white'>{Number(item.ongoingPerformance).toFixed(0)}%</div>
														}
													</td>
													<td align='center'>
														{item.completedProjects}
													</td>
													<td align='center'>{item.completedCost}</td>
													<td align='center'>{
														Number(item.completedPerformance)>=70?
														<div class='bg-success px-2 rounded text-white'>{Number(item.completedPerformance).toFixed(0)}%</div>
														:Number(item.ongoingPerformance)>=50?
														<div class='bg-warning px-2 rounded text-white'>{Number(item.completedPerformance).toFixed(0)}%</div>
														:
														<div class='bg-danger px-2 rounded text-white'>{Number(item.completedPerformance).toFixed(0)}%</div>
														}
													</td>
												</tr>
												:null
												
									);	
								})
							}
						</>
						:<></>
					}
					</tbody>
					</table>
				</div>
			</div>
			
		</div>
		
	</div>
	</>

);
};
export default JComponent;